
import View from '@/apps/unrealos/views/solutions';
import { getCustomServerSideProps, GetServerSidePropsContext } from '@/utils/serverSide';

export default View;

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
) => {
  return getCustomServerSideProps(
    context,
    {
      config: {
        layout: {
          name: 'unrealos',
        },
        protected: false,
      },
    },
    {
      redirectIfLogged: false,
      seoConfig: {
        title: 'Solutions',
        description: 'Unique solutions for your business',
      },
    },
  );
};
